module.exports = __webpack_public_path__ + "static/media/icon-award.0cf9a246.svg";